// node-modules
import Barba from 'barba.js/dist/barba';
import { TimelineMax, TweenLite } from 'gsap/TweenMax';

// others
import { initPlugins, destroyPlugins } from '@/scripts/plugins/index';

export default Barba.BaseTransition.extend({
  start() {
    Promise
      .all([this.newContainerLoading])
      .then(this.fadeOut.bind(this))
      .then(this.fadeIn.bind(this));
  },

  fadeOutAnimation() {
    return new Promise((resolve) => {
      TweenLite.to(this.oldContainer, 0.5, {
        autoAlpha: 0,
        onComplete() {
          resolve(true);
        },
      });
    });
  },

  fadeOut() {
    return new Promise(async (resolve) => {
      const timeout = await Promise.all([
        this.fadeOutAnimation(),
        destroyPlugins(),
      ]);
      if (timeout) {
        resolve(true);
      }
    });
  },

  async fadeIn() {
    const tl = new TimelineMax();
    TweenLite.set(window, { scrollTo: { y: 0, autoKill: false } });

    const timeout = [
      await initPlugins(this.newContainer, true),
    ];

    if (timeout) {
      TweenLite.fromTo(this.newContainer, 0.5, { autoAlpha: 0 }, {
        autoAlpha: 1,
        onComplete: () => {
          tl
            .staggerFromTo('[data-main-animation="fade-in-left"]', 1, { autoAlpha: 0, x: 50 }, {
              x: 0,
              autoAlpha: 1,
              clearProps: 'all',
            }, 0.2, 0)
            .staggerFromTo(Array.from(document.querySelectorAll('[data-main-animation="fade-in-right"]')).reverse(), 1, { autoAlpha: 0, x: -50 }, {
              x: 0,
              autoAlpha: 1,
              clearProps: 'all',
            }, 0.2, 0)
            .staggerFromTo('[data-main-animation="fade-in-up"]', 1, { autoAlpha: 0, y: 100 }, {
              y: 0,
              autoAlpha: 1,
              clearProps: 'all',
            }, 0.2, 0);
          this.done();
        },
      });
    }
  },
});



// WEBPACK FOOTER //
// ./components/PageNavigation/transition.js